import React from 'react';
import ReactDOM from 'react-dom/client';

import { Amplify } from 'aws-amplify';

import './index.css';
import App from './App';
import amplifyconfiguration from './amplifyconfiguration';


Amplify.configure(amplifyconfiguration);


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
